<app-accordion class="w-100 form-container" >
  <ng-container *ngIf="!displayOnlyFileEvidence">
    <div class="table-container w-100" [ngStyle]="{'order': displayOnIncidentFile ? '4': null}" [ngStyle]="{'min-width': displayOnModal ? '400px' : '320px'}">
      <app-panel [title]="'Asistencias'" [titleFirts]="true" id="assistances" [opened]="true">
        <app-table
        [data]="_dispatchTable"
        [deletePermissionRoute]="true"
        [editBtnRoute]="(incidentClose) ? false : true"
        [deleteBtnRoute]="(incidentClose) ? false : true"
        [loadData]="loadAssistances == 1 ? true : false"
        [deleteBtnIcon]="'fa-solid fa-xmark fa-lg'"
        [enablePagination]="true"
        [rowsPerPage]="3"
        [deleteBtnTooltip]="_appService.CoreCommonLiterals.ButtonCancel"
        [customIconSize]="'fa-3x'"
        [noneDataMessage]="'No hay asistencias registradas'"
        (onEdit)="openEditSelectedElement($event, 'dispatch', 'Despacho',  (incidentData? 'incident': 'fileData'))"
        (onRemove)="openRemoveModal($event, 'dispatch')">
        </app-table>
        <hr class="mb-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1); margin: auto;" [ngClass]="{'d-none': !_dispatchTable?.Elements?.length}">
        <div class="d-flex justify-content-end align-items-center mt-2 w-100">
          <button type="button" class="btn btn-primary" id="add-dispatch" (click)="openAddModal(incidentElementTypes.Dispatches)" [disabled]="(incidentClose || loadAssistances === 1)">
            <i class="fas fa-plus"></i> {{_appService.CoreCommonLiterals?.AddAssistance}}
          </button>
        </div>
      </app-panel>
    </div>
    <div class="table-container w-100" [ngStyle]="{'order': displayOnIncidentFile ? '5': null}">
      <app-panel [title]="'Pistas involucradas'" [titleFirts]="true" id="lanes" [opened]="true">
        <app-table *ngIf="_lanesInvolvedTable"
        [data]="_lanesInvolvedTable"
        [deletePermissionRoute]="true"
        [editBtnRoute]="(incidentClose) ? false : true"
        [deleteBtnRoute]="(incidentClose) ? false : true"
        [loadData]="loadDataLanes == 1 ? true : false"
        [enablePagination]="true"
        [rowsPerPage]="3"
        [customIconSize]="'fa-3x'"
        [noneDataMessage]="'No hay pistas registradas'"
        (onEdit)="openEditSelectedElement($event, 'lanes', 'Pista',  (incidentData? 'incident': 'fileData'))"
        (onRemove)="openRemoveModal($event, 'lanes')">
        </app-table>
        <hr class="mb-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1); margin: auto;" [ngClass]="{'d-none': !_lanesInvolvedTable?.Elements?.length}">
        <div class="d-flex justify-content-end align-items-center mt-2 w-100">
          <button type="button" class="btn btn-primary"  id="add-lane" (click)="openAddModal(incidentElementTypes.Lanes)" [disabled]="(incidentClose || loadDataLanes === 1 || !vialAxes)">
            <i class="fas fa-plus"></i> Agregar pista
          </button>
        </div>
      </app-panel>
    </div>
    <div class="table-container w-100" [ngStyle]="{'order': displayOnIncidentFile ? '2': null}">
      <app-panel [title]="'Vehículos involucrados'" [titleFirts]="true" id="vehicles" [opened]="true">
        <app-table
        *ngIf="_vehiclesInvolved"
        [data]="_vehiclesInvolved"
        [deletePermissionRoute]="true"
        [editBtnRoute]="(incidentClose) ? false : true"
        [deleteBtnRoute]="(incidentClose) ? false : true"
        [loadData]="loadDataVehicles == 1 || loadAddVehicles == 1 ? true : false"
         [enablePagination]="true"
        [rowsPerPage]="3"
        [customIconSize]="'fa-3x'"
        [noneDataMessage]="'No hay vehículos registrados'"
        (onEdit)="openEditSelectedElement($event, 'vehicle','Vehículo', (incidentData? 'incident': 'fileData'))"
        (onRemove)="openRemoveModal($event, 'vehicle')">
        </app-table>
        <hr class="mb-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1); margin: auto;" [ngClass]="{'d-none': !_vehiclesInvolved?.Elements?.length}">
        <div class="d-flex justify-content-end align-items-center mt-2 w-100">
          <button type="button" class="btn btn-primary" id="add-vehicle" (click)="openAddModal(incidentElementTypes.InvolvedVehicles)" [disabled]="(incidentClose || loadDataVehicles == 1)">
            <i class="fas fa-plus"></i> Agregar vehículo
          </button>
        </div>
      </app-panel>
    </div>
    <div class="table-container w-100" [ngStyle]="{'order': displayOnIncidentFile ? '3': null}">
      <app-panel [title]="'Personas involucradas'" [titleFirts]="true" id="people" [opened]="true">
        <app-table *ngIf="_peopleInvolved"
        [data]="_peopleInvolved"
        [deletePermissionRoute]="true"
        [editBtnRoute]="(incidentClose) ? false : true"
        [deleteBtnRoute]="(incidentClose) ? false : true"
        [loadData]="loadDataPersons == 1 || loadAddPersons === 1 ? true : false"
         [enablePagination]="true"
        [rowsPerPage]="3"
        [customIconSize]="'fa-3x'"
        [noneDataMessage]="'No hay personas registradas'"
        (onEdit)="openEditSelectedElement($event, 'people', 'Persona', (incidentData? 'incident': 'fileData'))"
        (onRemove)="openRemoveModal($event, 'people')"
        ></app-table>
        <hr class="mb-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1); margin: auto;" [ngClass]="{'d-none': !_peopleInvolved?.Elements?.length}">
        <div class="d-flex justify-content-end align-items-center mt-2 w-100">
          <button type="button" class="btn btn-primary" id="add-people" (click)="openAddModal(incidentElementTypes.InvolvedPeople)" [disabled]="(loadAddPersons == 1 || incidentClose)">
            <i class="fas fa-plus"></i> Agregar persona
          </button>
        </div>
      </app-panel>
    </div>
    <div class="table-container w-100" [ngStyle]="{'order': displayOnIncidentFile ? '1': null}">
      <app-panel [title]="'Daños preliminares'" [titleFirts]="true" id="damages" [opened]="true">
        <app-table *ngIf="_damageRegisterDataTable"
        [data]="_damageRegisterDataTable"
        [deletePermissionRoute]="true"
        [editBtnRoute]="(incidentClose) ? false : true"
        [deleteBtnRoute]="(incidentClose) ? false : true"
        [customIconSize]="'fa-3x'"
         [enablePagination]="true"
        [rowsPerPage]="3"
        [noneDataMessage]="'No hay daños registrados'"
        (onEdit)="openEditSelectedElement($event, 'damages', ' ',  (incidentData? 'incident': 'fileData'))"
        (onRemove)="openRemoveModal($event, 'damages')">
        </app-table>
        <hr class="mb-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1); margin: auto;" [ngClass]="{'d-none': !_damageRegisterDataTable?.Elements?.length}">
        <div class="d-flex justify-content-end align-items-center mt-2 w-100">
          <button type="button" class="btn btn-primary" id="add-damage" (click)="openAddModal(incidentElementTypes.DamageRegister)" [disabled]="(incidentClose)">
            <i class="fas fa-plus"></i> Agregar daño
          </button>
        </div>
      </app-panel>
    </div>
  </ng-container>
 
  <div class="table-container w-100" *ngIf="displayOnlyFileEvidence">
    <app-panel [title]="'Archivos del Evento'" [titleFirts]="true" id="files" [opened]="true">
      <app-table *ngIf="_fileEvidenceTable"
      [data]="_fileEvidenceTable"
      [deletePermissionRoute]="true"
      [editBtnRoute]="(incidentClose) ? false : true"
      [deleteBtnRoute]="(incidentClose) ? false : true"
      [downloadBtnRoute]="true"
      [customIconSize]="'fa-3x'"
      [enablePagination]="true"
      [rowsPerPage]="3"
      [noneDataMessage]="'No hay archivos registrados'"
      (onEdit)="openEditSelectedElement($event, 'file', 'Archivo', (incidentData? 'incident': 'fileData'))"
      (onRemove)="openRemoveModal($event, 'file')"
      (onDownload)="downloadFileTable($event)"
      ></app-table>
      <hr class="mb-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1); margin: auto;" [ngClass]="{'d-none': !_fileEvidenceTable?.Elements?.length}">
      <div class="d-flex justify-content-end align-items-center mt-2 w-100">
        <button type="button" class="btn btn-primary" id="add-file" [disabled]="incidentClose" (click)="openAddModal(incidentElementTypes.Files)">
          <i class="fas fa-plus"></i> Nuevo archivo
        </button>
      </div>
    </app-panel>
  </div>
</app-accordion>

<modal-confirm #confirmRemove
id="confirm-remove"
[title]="_removeType == 'dispatch' ? (_appService?.CoreCommonLiterals?.ButtonCancel + ' despacho') : _appService?.CoreCommonLiterals?.Delete"
[content]="_appService?.CoreCommonLiterals?.SureYouWantToContinue"
[submitButtonText]="_appService?.CoreCommonLiterals?.ButtonConfirm"
(submit)="remove()"
[closeButtonText]="_appService?.CoreCommonLiterals?.ButtonCancel">
</modal-confirm>


<app-incident-element-modal
  #elementModal
  (onClose)="onCloseSettings($event)"
  [data]="incidentElements ? incidentElements : null"
  (dataChange)="saveDataElements($event)"
></app-incident-element-modal>


